import React from 'react';
import ClientInvoiceAdminItem from '../../../Domain/ClientInvoiceAdminItem';
import ClientInvoiceService from '../../../Services/ClientInvoiceService';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import dateTimeHelper from '../../../Helpers/datetimeHelper';

export default class EditClientInvoiceWindowDescription extends React.Component {
  static titleForCreate = 'Add New Client Invoice';
  static titleForEdit = (editedItem) => `Edit Client Invoice (#${editedItem.CiId})`;
  static itemType = ClientInvoiceAdminItem;
  static serviceFunction = (edited) => ClientInvoiceService.EditInvoice(edited, null, false, null);
  static lastCiBtid = '';

  getSelected() {}

  getSearchParameters() {}

  getAllItemInTheSearchAreSelected() {}

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      hide: (item) => (item.CiStatusCode === 3) && !item.IsCopyAction,
      fields: [
        {
          fieldName: 'ClientName',
          label: 'Client Name *',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
          validityChecker: ValidityHelper.forRequiredTextField,
          disabled: (item) => (item.CiStatusCode === 3) && !item.IsCopyAction,
        },
        {
          fieldName: 'CiRcyid',
          label: 'Currency',
          className: 'col-12',
          type: InputTypesEnum.CurrencySelect,
          disabled: (item) => (item.CiStatusCode === 2 || item.CiStatusCode === 3) && !item.IsCopyAction,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'CiBtid',
          label: 'Bill To Contact *',
          className: 'col-12',
          type: InputTypesEnum.ContactSelectForNewInvoice,
          disabled: (item) => (item.CiStatusCode === 2 || item.CiStatusCode === 3) && !item.IsCopyAction,
          validityChecker: ValidityHelper.forRequiredSelectField,
          idFilter: 'CiCcid',
          onFieldChange: EditClientInvoiceWindowDescription.onContactChange,
        },
        {
          fieldName: 'CiVatnumber',
          label: 'Billing To Client Tax # *',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.validityCheckerforVatNumber,
          disabled: (item) => (item.CiStatusCode === 3) && !item.IsCopyAction,
        },
        {
          fieldName: 'CiBillToClientName',
          label: 'Bill To Client Name',
          className: 'col-12',
          type: InputTypesEnum.Text,
          disabled: (item) => (item.CiStatusCode === 2 || item.CiStatusCode === 3) && !item.IsCopyAction,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'OfficeName',
          label: 'Office',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
          disabled: (item) => (item.CiStatusCode === 2 || item.CiStatusCode === 3) && !item.IsCopyAction,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'CiDaysToPay',
          label: 'Days To Pay',
          className: 'col-12',
          type: InputTypesEnum.Number,
          disabled: (item) => (item.CiStatusCode === 2 || item.CiStatusCode === 3) && !item.IsCopyAction,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'CiInterestRate',
          label: 'Late Fee % *',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          disabled: (item) => (item.CiStatusCode === 2 || item.CiStatusCode === 3) && !item.IsCopyAction,
          validityChecker: EditClientInvoiceWindowDescription.validityForInterestRate,
        },
        {
          fieldName: (item) => EditClientInvoiceWindowDescription.getDate(item),
          label: 'Invoiced On *',
          className: 'col-12',
          type: InputTypesEnum.Date,
          disabled: (item) => (item.CiStatusCode === 2 || item.CiStatusCode === 3) && !item.IsCopyAction,
          validityChecker: ValidityHelper.forRequiredDateLatterThanToday,
        },
        {
          fieldName: (item) => EditClientInvoiceWindowDescription.getDueDate(item),
          label: 'Due On *',
          className: 'col-12',
          type: InputTypesEnum.Date,
          disabled: (item) => (item.CiStatusCode === 2 || item.CiStatusCode === 3) && !item.IsCopyAction,
          validityChecker: ValidityHelper.forRequiredDateLatterThanToday,
        },
        {
          fieldName: 'FulfillmentDate',
          label: 'Fullfillment Date *',
          className: 'col-12',
          type: InputTypesEnum.Date,
          validityChecker: EditClientInvoiceWindowDescription.validateFulfillmentDate,
          hide: (item) => item.CiOfficeId && item.CiOfficeId.toString() !== '9',
          disabled: (item) => (item.CiStatusCode === 2 || item.CiStatusCode === 3) && !item.IsCopyAction,
        },
      ],
    },
    {
      label: 'Invoice Details',
      fields: [
        {
          fieldName: 'CiInvoiceNumber',
          label: 'Client Invoice #',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'CiInternalReferenceNumber',
          label: 'Internal Reference Number',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => (item.CiStatusCode === 3) && !item.IsCopyAction,
        },
        {
          fieldName: 'CiPonumber',
          label: 'Purchase Order #',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => (item.CiStatusCode === 3) && !item.IsCopyAction,
        },
        {
          fieldName: 'CiDefaultReportName',
          label: 'Invoice Form *',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: EditClientInvoiceWindowDescription.getInvoiceFormOptions(),
          validityChecker: ValidityHelper.forRequiredSelectField,
          hide: (item) => (item.CiStatusCode === 3) && !item.IsCopyAction,
        },
        {
          fieldName: 'CiReportOrder',
          label: 'Form Order',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: EditClientInvoiceWindowDescription.getReportOrderOptions(),
          validityChecker: ValidityHelper.AlwaysFlawless,
          showFilterAt: 2,
          hide: (item) => (item.CiStatusCode === 3) && !item.IsCopyAction,
        },
        {
          fieldName: 'CiReportGroup1',
          label: 'Form Group 1',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: EditClientInvoiceWindowDescription.getReportGroupOptions(),
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => (item.CiStatusCode === 3) && !item.IsCopyAction,
        },
        {
          fieldName: 'CiReportGroup2',
          label: 'Form Group 2',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: EditClientInvoiceWindowDescription.getReportGroupOptions(),
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => (item.CiStatusCode === 3) && !item.IsCopyAction,
        },
        {
          fieldName: 'CiInvoiceComment',
          label: 'Invoice Comments',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => (item.CiStatusCode === 3) && !item.IsCopyAction,
        },
      ],
    },
  ];

  static validityForInterestRate(e, item) {
    return item.CiInterestRate === ''
      ? "This field can't be empty."
      : ValidityHelper.forRequiredNumberFieldAtLeastZero(e);
  }

  static validateFulfillmentDate(e, item) {
    if (dateTimeHelper.addDaysToDate(EditClientInvoiceWindowDescription.getDate(item), 1) > item.FulfillmentDate) {
      return 'Fulfillment date cannot be before Invoiced On date.';
    }
    return '';
  }

  static onContactChange(editedItem) {
    if (editedItem.CiBtid !== EditClientInvoiceWindowDescription.lastCiBtid && !editedItem.isEditing) {
      if (editedItem.CiBtid) {
        const contact = editedItem.ClientContacts.find((c) => c.contactId.toString() === editedItem.CiBtid.toString());
        editedItem.CiVatnumber = contact.vatnumber;
        if (contact.billToClientName) editedItem.CiBillToClientName = contact.billToClientName;
        else editedItem.CiBillToClientName = editedItem.ClientName;
        editedItem.OfficeName = contact.officeName;
        editedItem.CiOfficeId = contact.officeId;
      } else if (!editedItem.CiBtid) {
        editedItem.CiVatnumber = '';
        editedItem.CiBillToClientName = '';
      }
    }
    editedItem.isEditing = false;
    EditClientInvoiceWindowDescription.lastCiBtid = editedItem.CiBtid;
  }

  static getDueDate(item) {
    if (!isNaN(item.CiDaysToPay)) {
      item.CiInvoiceDueDate = dateTimeHelper.addDaysToDate(item.CiDate, item.CiDaysToPay);
    }
    return item.CiInvoiceDueDate;
  }

  static getDate(item) {
    item.CiDate = new Date(dateTimeHelper.toYYYYsMMsDD(new Date()));
    return item.CiDate;
  }

  static getInvoiceFormOptions() {
    return [
      { value: null, label: '' },
      { value: 'Client Invoice Detail', label: 'Detailed US' },
      { value: 'Client Invoice Detail Intl', label: 'Detailed Belgium' },
      { value: 'Client Invoice Detail Brazil', label: 'Detailed Brazil' },
      { value: 'Client Invoice Detail China Chinese', label: 'Detailed China Mandarin' },
      { value: 'Client Invoice Detail China English', label: 'Detailed China English' },
      { value: 'Client Invoice Detail India', label: 'Detailed India' },
      { value: 'Client Invoice Detail Singapore', label: 'Detailed Singapore (multi currency)' },
      { value: 'Client Invoice Detail Singapore single currency', label: 'Detailed Singapore (single currency)' },
      { value: 'Client Invoice Summary', label: 'Summary US' },
      { value: 'Client Invoice Summary Intl', label: 'Summary Belgium' },
      { value: 'Client Invoice Summary Brazil', label: 'Summary Brazil' },
      { value: 'Client Invoice Summary China Chinese', label: 'Summary China Mandarin' },
      { value: 'Client Invoice Summary China English', label: 'Summary China English' },
      { value: 'Client Invoice Summary India', label: 'Summary India' },
    ];
  }

  static getReportOrderOptions() {
    return [
      { value: null, label: '' },
      { value: 'EvalDate', label: 'Assignment Date' },
      { value: 'UnitName', label: 'Location Name' },
      { value: 'UnitId', label: 'Apollo Location ID' },
    ];
  }

  static getReportGroupOptions() {
    return [
      { value: null, label: '' },
      { value: 'Ad-Hoc', label: 'Ad-Hoc' },
      { value: 'Fee Reason', label: 'Fee Reason' },
      { value: 'Location', label: 'Location Name' },
      { value: 'Country', label: 'Country' },
      { value: 'Project', label: 'Project' },
      { value: 'Location Group', label: 'Location Group' },
      { value: 'Evaluation Date', label: 'Evaluation Date' },
      { value: 'Level2', label: 'Location Level 2' },
      { value: 'Level3', label: 'Location Level 3' },
      { value: 'Level4', label: 'Location Level 4' },
      { value: 'Level5', label: 'Location Level 5' },
      { value: 'Wave', label: 'Assignment Wave' },
    ];
  }
}
